import { AnalyticsMetaKeys as key } from '../../../services/analytics/formatters/meta-keys'
import { DOMEvents } from '../../../utils/dom'
import { ScreenUtils } from '../../../utils/screen'
import { AnalyticsEvent } from '../event'
import { GlobalDataFormatter } from './global-data'
import { MParticleProvider } from './mparticle/events/default'

export interface IScrollData {
  [key.PAGEVIEW_PRCNT]?: number
  [key.STORYVIEW_PRCNT]?: number
}

export class ScrollDepth extends AnalyticsEvent {
    // FIXME: Rename the class name `ScrollDepth` to `PageScroll` after removing
    //        old class file `src/domain/analytics/providers/mparticle/events/scroll/page-scroll.ts`

    private shouldTrackPageViewPercentage: boolean
    private shouldTrackStoryViewPercentage: boolean
    private maxPageViewPercentage: number
    private maxStoryViewPercentage: number

    public constructor(public type: string, public value: string, public action: string, public element?: Element) {
        super(type, value, action, element)

        this.setScrollTrackConfig()
        this.maxPageViewPercentage = 0
        this.maxStoryViewPercentage = 0
        if (this.shouldTrackPageViewPercentage || this.shouldTrackStoryViewPercentage) {
          document.addEventListener(DOMEvents.scroll, this.scrollListner.bind(this))
        }
    }

    /**
     * Handle event
     */
    public handle(event?: Event): void {

        /**
         * Event Handler: create Attributes list and send it to vendors providers
         * @var data will be different for each event, and for each provider
         *
         */
        // Get attributes list
        const dataAttrs = this.getGeneralAttributesList()

        const pageViewPercentage = this.shouldTrackPageViewPercentage ?
                                          { [key.PAGEVIEW_PRCNT]: this.maxPageViewPercentage } : {}
        const storyViewPercentage = this.shouldTrackStoryViewPercentage ?
                                          { [key.STORYVIEW_PRCNT]: this.maxStoryViewPercentage } : {}
        const scrollData: IScrollData = {...pageViewPercentage, ...storyViewPercentage}
        const metaProperties = {...this.metaProperties, scrollData}

        // Get Data Values
        const globalFormatter = new GlobalDataFormatter(metaProperties)
        const data: any = {}
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr, event)
                if(attrValue !== '') {
                    data[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error in class ScrollDepth', e)
            }
        })

        const controlFields = this.getControlFields()

        if(controlFields.mparticle) {
            const mparticle = new MParticleProvider(data, this.type, this.value, this.action, this.element)
            mparticle.setMetaProperties(metaProperties)
            mparticle.handle(event)
        }

    }

    private setScrollTrackConfig() {
      const extraAttributes = [...this.getGeneralAttributesList(),
                             ...this.getProviderAttributesList('mparticle', [])]
      this.shouldTrackPageViewPercentage = extraAttributes.includes(key.PAGEVIEW_PRCNT) ||
        extraAttributes.includes(key.PAGEVIEW_PRCNT_DEPRECATED)
      this.shouldTrackStoryViewPercentage = extraAttributes.includes(key.STORYVIEW_PRCNT) ||
        extraAttributes.includes(key.STORYVIEW_PRCNT_DEPRECATED)
    }

    private scrollListner(): void {
      if (this.shouldTrackPageViewPercentage) {
        const currentPageViewPercentage = ScreenUtils.currentPageViewPercentage()
        if (currentPageViewPercentage > this.maxPageViewPercentage) {
          this.maxPageViewPercentage = currentPageViewPercentage
        }
      }

      if (this.shouldTrackStoryViewPercentage && this.element) {
        const currentStoryViewPercentage = ScreenUtils.currentElementViewPercentage(this.element)
        if (currentStoryViewPercentage > this.maxStoryViewPercentage) {
          this.maxStoryViewPercentage = currentStoryViewPercentage
        }
      }
    }

}
